import _classCallCheck from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/elixx/src/eternal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { BlendFunction } from "./blending/BlendFunction.js";
import { Effect } from "./Effect.js";
var fragment = "void mainImage(const in vec4 inputColor, const in vec2 uv, out vec4 outputColor) {\r\n\r\n\tfloat sum = inputColor.r + inputColor.g + inputColor.b;\r\n\r\n\toutputColor = vec4(vec3(sum / 3.0), inputColor.a);\r\n\r\n}\r\n";
/**
 * A color average effect.
 */

export var ColorAverageEffect =
/*#__PURE__*/
function (_Effect) {
  _inherits(ColorAverageEffect, _Effect);

  /**
   * Constructs a new color average effect.
   *
   * @param {BlendFunction} [blendFunction=BlendFunction.NORMAL] - The blend function of this effect.
   */
  function ColorAverageEffect() {
    var blendFunction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : BlendFunction.NORMAL;

    _classCallCheck(this, ColorAverageEffect);

    return _possibleConstructorReturn(this, _getPrototypeOf(ColorAverageEffect).call(this, "ColorAverageEffect", fragment, {
      blendFunction: blendFunction
    }));
  }

  return ColorAverageEffect;
}(Effect);